import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-transferencia-fichas-edit',
  templateUrl: './transferencia-fichas-edit.component.html',
  standalone: false
})
export class TransferenciaFichasEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/transferencia-ficha`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Transferência de Fichas', link: '/transferencia-fichas' }, { label: 'Edição Transferência de Fichas' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'transferencia-fichas',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('transferencia-fichas').subscribe(data => {
        this.fields = data;
    });
  }

}
